import React, {FC, useState} from 'react';
import classNames from 'classnames';

type Props = {
  avatar: string;
  name: string;
  email: string;
};

const ReferralsDetails: FC<Props> = ({avatar, name}) => {
  const [loaded, setLoaded] = useState(false);
  const validateUrl = (url: string) => {
    try {
      const parsedURL = new URL(url);
      const imageExtensionPattern = /\.(jpg|jpeg|png|gif|bmp|webp)(\?.*)?$/i;
      return imageExtensionPattern.test(parsedURL.toString());
      return true;
    } catch {
      return false;
    }
  };
  const isImageUrlValid = validateUrl(avatar);
  return (
    <article className="flex pt-2 pb-5 justify-center items-center">
      <img
        className={classNames(
          ' w-24 h-24 mr-4 object-cover rounded-full transition-opacity duration-300',
          {
            'opacity-100': loaded,
            'opacity-0': !loaded,
          },
        )}
        src={
          isImageUrlValid
            ? avatar
            : 'https://firebasestorage.googleapis.com/v0/b/wellnite-chat-production.appspot.com/o/Image%2Fplaceholer-image.png?alt=media&token=e6e44bf5-e204-4d0c-912b-6afd47b4f167'
        }
        alt="avatar"
        onLoad={() => setLoaded(true)}
      />
      <div className="text-center">
        <h2 className="leading-7 text-lg font-black !font-normal">{name}</h2>
      </div>
    </article>
  );
};

export default ReferralsDetails;
